import React, { ReactNode } from 'react';

type ErrorType = Error | null;
type ErrorInfoType = React.ErrorInfo | null;
interface ErrorBoundaryState {
  hasError: boolean;
  error: ErrorType;
  info: ErrorInfoType;
}

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback: (error: ErrorType, info: ErrorInfoType) => ReactNode;
}
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error: ErrorType, info: ErrorInfoType) {
    return { hasError: true, error, info };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    ErrorBoundary.getDerivedStateFromError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback(this.state.error, this.state.info);
    }

    return this.props.children;
  }
}
